import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.8407 6.94374C19.3136 7.40807 19.3206 8.16783 18.8562 8.64073L10.6062 17.0431C10.3806 17.2729 10.072 17.4024 9.7499 17.4023C9.42781 17.4023 9.11925 17.2728 8.89362 17.043L5.14362 13.2226C4.67936 12.7497 4.68642 11.9899 5.15938 11.5257C5.63234 11.0614 6.3921 11.0685 6.85636 11.5414L9.75011 14.4894L17.1437 6.95927C17.6081 6.48637 18.3678 6.47942 18.8407 6.94374Z",
		fill: "currentColor"
	})
});
export default SvgIconCheck;
